import { useQuery } from 'react-query';
import { IFGAMappableSchemaResponse } from 'types/api';
import { parseMappableFGASchema } from 'utils/fgaMapping';
import { get } from './api';
import { API_ROUTES } from './apiRoutes';
import QueryKeys from './queryKeys';

const getMappableFGASchema = async () => {
	const res = await get<IFGAMappableSchemaResponse>(API_ROUTES.fga.mappable);
	return res.data;
};

const useMappableFGASchema = () =>
	useQuery({
		queryKey: QueryKeys.fgaMappableSchema,
		queryFn: getMappableFGASchema,
		select: parseMappableFGASchema,
		// Sections load their rows once; a refetch mid-edit would re-sort stored custom roles under
		// them and drop or corrupt rows on the next submit.
		staleTime: Infinity
	});

export { useMappableFGASchema };
